@if (message(); as outcomeMessage) {
  <dm-alert
    class="lp-form-alert__alert"
    [color]="variant()"
    [tinted]="true"
    alertstyle="floating"
    [initialvisible]="true"
    [closable]="false"
    [dismissbuttonlabel]="''"
  >
    <dm-icon slot="icon" [name]="resolvedIcon()" size="md" aria-hidden="true" />
    <p slot="text" class="lp-form-alert__message">{{ outcomeMessage }}</p>
  </dm-alert>
}
